import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { useMainContext } from '../core/contexts/main'
import i18next from 'i18next'
import GlobalLoading from '../components/layouts/loading/GlobalLoading'
import CrispProvider from '../components/layouts/crisp/components/CrispProvider'
import { useSetAxiosHeaders } from '../core/hooks/useAxios'
import AuthPage from './auth/Auth'
import AnalyzePage from './analyze'
import { SocketProvider } from '../core/contexts/socket'
import { SocketContentProvider } from '../core/contexts/socket-content'
import { PredictContextProvider } from './analyze/context/PredictContextProvider'
import DepositCoinPage from './wallet/deposit/coin/DepositCoinPage'
import TransactionsPage from './transactions'
import UserInvitePage from './user-invite'
import SwapPage from './swap'
import MainAnalyzePage from './analyze/Main'
import NotificationsPage from './notifications'
import TelegramBotPage from './telegram'

const UserWallets = lazy(() => import('./wallet/main/NewUserWallet'))
const PlansPage = lazy(() => import('./plans/index'))
const SuccessPaymentCallback = lazy(() => import('./payment/success'))
const PaymentFailedCallback = lazy(() => import('./payment/failed'))
const UserProfile = lazy(() => import('./UserProfile'))

const Index = () => {
	const {
		main: { lang, theme },
		profile: { token },
	} = useMainContext()

	useSetAxiosHeaders()

	useEffect(() => {
		i18next.changeLanguage(lang)
		//eslint-disable-next-line
	}, [])

	useEffect(() => {
		if (theme === 'dark') {
			document.documentElement.classList.add('dark')
		} else {
			document.documentElement.classList.remove('dark')
		}
		if (lang === 'en') {
			document.dir = 'ltr'
		} else {
			document.dir = 'rtl'
		}
	}, [theme])

	return (
		<Router basename={process.env.PUBLIC_URL}>
			<Suspense fallback={<GlobalLoading />}>
				<SocketProvider>

					<SocketContentProvider>

						<CrispProvider>

							{token ? (
								<PredictContextProvider>
									<Routes>
										<Route index path='/analyze/assistant/crypto?step=assistant' element={<MainAnalyzePage />} />

										{routes.map((route) => (
											<Route path={route.path} element={route.element} />
										))}

										<Route path='*' element={<Navigate to='/analyze/assistant/crypto?step=assistant' replace />} />
									</Routes>
								</PredictContextProvider>
							) : (
								<Routes>
									<Route path="/auth/*" element={<AuthPage />} />

									<Route path="/auth/signup" element={<AuthPage />} />
									<Route path="/auth/signup/otp" element={<AuthPage />} />
									<Route path="/auth/signin" element={<AuthPage />} />
									<Route path="/auth/signin/otp" element={<AuthPage />} />
									<Route path="/auth/forget-password" element={<AuthPage />} />

									<Route path="*" element={<Navigate to="/auth/signin" replace />} />
								</Routes>
							)}
						</CrispProvider>
					</SocketContentProvider>
				</SocketProvider>
			</Suspense>
		</Router>
	)
}

const routes = [
	{ path: '/transactions', element: <TransactionsPage /> },
	{ path: '/transactions/:subpage', element: <TransactionsPage /> },
	{ path: '/swap', element: <SwapPage /> },
	{ path: '/wallet', element: <UserWallets /> },
	{ path: '/wallet/deposit-coin', element: <DepositCoinPage /> },
	{ path: '/profile', element: <UserProfile /> },
	{ path: '/analyze', element: <AnalyzePage /> },
	{ path: '/analyze/:mode/:market', element: <AnalyzePage /> },
	{ path: '/invite-friends', element: <UserInvitePage /> },
	{ path: '/plans', element: <PlansPage /> },
	{ path: '/notifications', element: <NotificationsPage /> },
	{ path: '/telegram', element: <TelegramBotPage /> },
	{ path: '/payment/success', element: <SuccessPaymentCallback /> },
	{ path: '/payment/failed', element: <PaymentFailedCallback /> },
]

export default Index
